import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useCartIntermediateContext } from '../../../context/CartIntermediateContext'

export const CartIntermediateProductInfoQuantity: FC = () => {
  const { quantity } = useCartIntermediateContext()

  return (
    <div className="text-s text-dark-primary-medium">
      <FormattedMessage
        id="general.label.quantityN"
        values={{ amount: quantity }}
      />
    </div>
  )
}
